import dynamic from 'next/dynamic';

const TopScroll = dynamic(() => import('./TopScroll'));

export default TopScroll;
